module.exports = __webpack_public_path__ + "img/logo.eb2bd662.png";